import { responsiveVariables } from "../../utilities/props.js";
import "./inset.css";
const getInsetStyles = (value, side) => {
    if (value === undefined)
        return null;
    const suffix = side ? `-${side}` : "-all";
    const variableName = `--rs-inset${suffix}`;
    const variables = responsiveVariables(variableName, value);
    return { variables };
};
export default getInsetStyles;
